import { useI18n } from "../../i18n";

const COLORS = {
  draft: "bg-slate-100 text-slate-600",
  pending_approval: "bg-amber-100 text-amber-800",
  in_review: "bg-sky-100 text-sky-800",
  submitted: "bg-sky-100 text-sky-800",
  received: "bg-indigo-100 text-indigo-800",
  prepared: "bg-violet-100 text-violet-800",
  out_for_delivery: "bg-orange-100 text-orange-800",
  delivered: "bg-emerald-100 text-emerald-800",
  invoiced: "bg-navy/10 text-navy",
  cancelled: "bg-rose-100 text-rose-700",
};

// Customers see 4 stages: sent, received, ready for delivery, delivered.
export const STAGE_OF = { in_review: "sent", submitted: "sent", received: "received", prepared: "ready", out_for_delivery: "ready", delivered: "delivered", invoiced: "delivered" };
const STAGE_COLORS = { sent: COLORS.in_review, received: COLORS.received, ready: COLORS.out_for_delivery, delivered: COLORS.delivered };

export const StatusBadge = ({ status, testId, customer = false }) => {
  const { t } = useI18n();
  const stage = customer && STAGE_OF[status];
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${stage ? STAGE_COLORS[stage] : COLORS[status]}`}>
      {t(stage ? `cstage.${stage}` : `status.${status}`)}
    </span>
  );
};
